import { useState, type ReactNode } from 'react';

import styles from './collapsible-section.module.scss';

interface CollapsibleSectionProps {
  title: ReactNode;
  children: ReactNode;
  actions?: ReactNode;
  contentHeader?: ReactNode;
  stickyChromeTone?: 'base' | 'subtle';
  defaultCollapsed?: boolean;
}

export const CollapsibleSection = ({
  title,
  children,
  actions,
  contentHeader,
  stickyChromeTone = 'base',
  defaultCollapsed = false,
}: CollapsibleSectionProps) => {
  const [isCollapsed, setIsCollapsed] = useState(defaultCollapsed);
  const hasContentHeader = !isCollapsed && contentHeader != null && contentHeader !== false;

  return (
    <section className={styles.section}>
      <div
        className={styles.stickyChrome}
        data-expanded={!isCollapsed}
        data-has-content-header={hasContentHeader}
        data-tone={stickyChromeTone}
      >
        <header className={styles.header}>
          <button className={styles.toggle} onClick={() => setIsCollapsed((prev) => !prev)}>
            <span className={styles.chevron} data-collapsed={isCollapsed} />
            <h2>{title}</h2>
          </button>
          {actions}
        </header>
        {hasContentHeader ? contentHeader : null}
      </div>
      {!isCollapsed ? <div className={styles.content}>{children}</div> : null}
    </section>
  );
};
